import { useState, useEffect } from 'react';

const LATEST_VERSION = "2.5.0";
const STORAGE_KEY = "geniebot-last-seen-changelog";

export function useWhatsNew() {
  const [hasNewItems, setHasNewItems] = useState(false);

  useEffect(() => {
    const lastSeen = localStorage.getItem(STORAGE_KEY);
    setHasNewItems(lastSeen !== LATEST_VERSION);
  }, []);

  const markAsSeen = () => {
    localStorage.setItem(STORAGE_KEY, LATEST_VERSION);
    setHasNewItems(false);
  };

  return { hasNewItems, markAsSeen, latestVersion: LATEST_VERSION };
}
